import { Box, Divider, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';

import { ComplianceDisplay } from './components';

interface PCIComplienceProps {
    name: string;
    editTransactionCharges: boolean;
}

export const PCIComplience: React.FC<PCIComplienceProps> = ({ name, editTransactionCharges }) => {
    return (
        <Box>
            <Typography fontSize="24px" color="#434341" marginBottom="8px">
                PCI DSS Compliance and non Compliance
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '8px',
                }}
            />
            <Typography fontSize="14px" color="#434341" marginBottom="24px">
                I understand my obligation to be certified as compliant with the Payment Card
                Industry Data Security Standard (PCI DSS)
            </Typography>

            <Flex flexDirection="column" gap="24px">
                <ComplianceDisplay
                    heading="Worldpay’s SaferPayments(PCI DSS Compliance) Programme"
                    name={`${name}.worldPayCharges`}
                />
                <ComplianceDisplay
                    heading="Additional Charges"
                    name={`${name}.additionChargers`}
                    editTransactionCharges={editTransactionCharges}
                />
            </Flex>
        </Box>
    );
};
